if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        form: this.querySelector("form"),
        cart: document.querySelector("cart-drawer"),
        submitButton: this.querySelector('button[type="submit"]'),
        loadingButton: this.querySelector('button[type="submit"] .sm-loading'),
        productInfo: this.closest("product-info")
      };
      this.elements.form.querySelector("[name=id]").disabled = false;
      this.elements.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.hideErrors = this.dataset.hideErrors === "true";
    }
    onSubmitHandler(event) {
      var _a, _b, _c, _d, _e;
      event.preventDefault();
      // 获取实际被点击的按钮（支持多个提交按钮）
      const clickedButton = event.submitter || this.elements.submitButton;
      const isBuyNow = (clickedButton == null ? void 0 : clickedButton.dataset.buyNow) === "true";
      if (clickedButton.getAttribute("aria-disabled") === "true")
        return;
      this.handleErrorMessage();
      // 找到被点击按钮对应的加载元素
      const clickedLoadingButton = clickedButton.querySelector('.sm-product-form__submit-loading');
      // 禁用所有提交按钮并显示对应按钮的加载状态
      const allSubmitButtons = this.querySelectorAll('button[type="submit"]');
      allSubmitButtons.forEach(btn => {
        btn.setAttribute("aria-disabled", true);
      });
      if (clickedLoadingButton) {
        clickedLoadingButton.classList.remove("hidden");
      }
      const config = window.fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      const formData = new FormData(this.elements.form);
      if (this.elements.cart) {
        formData.append(
          "sections",
          (_b = (_a = this.elements.cart).getSectionsToRender) == null ? void 0 : _b.call(_a).map((section) => section.section || section.id)
        );
        formData.append("sections_url", window.location.pathname);
        (_d = (_c = this.elements.cart).setActiveElement) == null ? void 0 : _d.call(_c, document.activeElement);
      }
      const propertiesElements = (_e = this.elements.productInfo) == null ? void 0 : _e.querySelectorAll('[name^="properties["][name$="]"]');
      if (propertiesElements == null ? void 0 : propertiesElements.length) {
        for (const element of propertiesElements) {
          const property = element.getAttribute("name").replace("properties[", "").replace("]", "");
          const value = element.value;
          formData.append(`properties[${property}]`, value);
        }
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
        var _a2, _b2;
        if (response.status) {
          window.publish(window.PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.errors || response.description,
            message: response.message
          });
          this.handleErrorMessage(response.description);
          return;
        } else if (!this.elements.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        const pixelListNameElement = this.closest("[data-pixel-list-name]");
        const pixelListId = pixelListNameElement == null ? void 0 : pixelListNameElement.dataset.pixelListId;
        const pixelListName = pixelListNameElement == null ? void 0 : pixelListNameElement.dataset.pixelListName;
        const index = (pixelListNameElement == null ? void 0 : pixelListNameElement.dataset.pixelIndex) || 1;
        const items = [];
        let pixelValue = 0;
        if (response.items) {
          const data = JSON.parse(config.body);
          const dataItems = (data == null ? void 0 : data.items) || [];
          response.items.forEach((item, index2) => {
            const findItem = dataItems.find((i) => i.id == item.id);
            if (findItem)
              pixelValue += item.price * findItem.quantity;
            item.update_index = index2;
            item.update_quantity = findItem.quantity;
            items.push(item);
          });
        } else {
          response.update_index = index;
          response.update_quantity = formData.get("quantity");
          items.push(response);
          pixelValue = response.price * formData.get("quantity");
        }
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          cartData: response,
          productVariantId: formData.get("id"),
          pixel: {
            value: pixelValue,
            buttonName: "add",
            listId: pixelListId,
            listName: pixelListName,
            items
          }
        });
        if (isBuyNow) {
          window.location.href = "/checkout";
          return;
        }
        (_b2 = (_a2 = this.elements.cart).renderContents) == null ? void 0 : _b2.call(_a2, response, this);
        const modalsToClose = [];
        let currentElement = this;
        while (currentElement) {
          const parentModal = currentElement.parentElement == null ? void 0 : currentElement.parentElement.closest("modal-dialog, quick-add-modal");
          if (!parentModal)
            break;
          if (!modalsToClose.includes(parentModal))
            modalsToClose.push(parentModal);
          currentElement = parentModal;
        }
        modalsToClose.forEach((modal) => {
          var _a3;
          (_a3 = modal.close) == null ? void 0 : _a3.call(modal);
        });
      }).catch((e) => {
        console.error(e);
      }).finally(() => {
        var _a2;
        // 隐藏所有按钮的加载状态并恢复所有按钮
        const allSubmitButtons = this.querySelectorAll('button[type="submit"]');
        allSubmitButtons.forEach(btn => {
          const loadingBtn = btn.querySelector('.sm-product-form__submit-loading');
          if (loadingBtn) {
            loadingBtn.classList.add("hidden");
          }
          btn.removeAttribute("aria-disabled");
        });
        if ((_a2 = this.elements.cart) == null ? void 0 : _a2.classList.contains("is-empty"))
          this.elements.cart.classList.remove("is-empty");
      });
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors)
        return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".sm-product-form__error");
      if (!this.errorMessageWrapper)
        return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".sm-product-form__error-message");
      this.errorMessageWrapper.classList.toggle("hidden", !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
  customElements.define("product-form", ProductForm);
}
